import $ from 'jquery';
import _ from 'ext:lodash';
import Framework from 'framework';
import clubsStore from 'framework/stores/ClubsStore';
import SessionStorage from 'lib/session-storage';
import urlUtils from 'lib/url-utils';

export default class AddMembers {

	constructor(el, referralCode, referralSource, promotionName) {
		this.el = el;
		this.clubsStore = clubsStore;

		this.state = {
			clubId: null,
			clubInfo: null,
			juniors: 0,
			adults: 1,
			referralCode: referralCode,
			referralSource: referralSource,
			promotionName: promotionName
		};

		$('#adultMembers').on('change', () => {
			this.state.adults = $('#adultMembers').val();
			if(this.state.adults >= 11) {
				this.state.adults = 11;
			}
		});
		$('#juniorMembers').on('change', () => {
			this.state.juniors = $('#juniorMembers').val();
			if(this.state.juniors >= 10) {
				this.state.juniors = 10;
			}
		});

		var $this = $(this.el);
		$('#editLink', $this).on('click', this.redirectToLocationsPage.bind(this));
		$('#continueLink', $this).on('click', this.redirectToOMSPage.bind(this));
	}


	redirectToLocationsPage(){
		SessionStorage.set('selectedMembers', {adults: this.state.adults, juniors: this.state.juniors});
		window.location.href = Framework.global.lt.globalPageDrivers.global.lifeTimeLocationsAe;
	}

	redirectToOMSPage(){
		SessionStorage.set('selectedMembers', {adults: this.state.adults, juniors: this.state.juniors});
		let redirectHref = Framework.global.lt.globalPageDrivers.global.transition +
			'?clubId=' + this.state.clubId + '&adultQuantity=' + this.state.adults + '&juniorQuantity=' + this.state.juniors;

		if(this.state.referralCode && this.state.referralSource) {
			redirectHref += '&referral=' + this.state.referralCode + '&source=' + this.state.referralSource;
		}

		if(this.state.promotionName) {
			redirectHref += '&promotionName=' + this.state.promotionName + '&source=web';
		}

		window.location.href = redirectHref;
	}

	setState(newState) {
		_.assign(this.state, newState);
	}

	initialize(clubId) {
		if(clubId) {
			this.state.clubId = clubId;
		}
		// check url params for adult/junior quantities from oms
		const juniorQuantity = urlUtils.getUrlParameter('juniorQuantity');
		const adultQuantity = urlUtils.getUrlParameter('adultQuantity');

		if(juniorQuantity && adultQuantity) {
			this.state.adults = parseInt(adultQuantity, 10);
			$('#adultMembers').val(this.state.adults);
			this.state.juniors = parseInt(juniorQuantity, 10);
			$('#juniorMembers').val(this.state.juniors);
		} else{
			// check for previously selected values stored in session data
			let storedData = SessionStorage.get('selectedMembers');
			// set data if it exists
			if(storedData) {
				this.state.adults = parseInt(storedData.adults, 10);
				$('#adultMembers').val(this.state.adults);
				this.state.juniors = parseInt(storedData.juniors, 10);
				$('#juniorMembers').val(this.state.juniors);
			}
		}

		// set disabled buttons as needed
		if(this.state.adults === 11) {
			$('#adultAdd').attr('disabled', true);
		}

		if(this.state.adults === 1) {
			$('#adultRemove').attr('disabled', true);
		}

		if(this.state.juniors === 10) {
			$('#juniorAdd').attr('disabled', true);
		}

		if(this.state.juniors === 0) {
			$('#juniorRemove').attr('disabled', true);
		}

		let clubsData = this.clubsStore.getInitialData();

		if(!clubsData.pending && (clubsData.clubs && clubsData.clubs.length > 0)) {
			// populate results using clubsStore data
			this.getClubInfo(clubsData);
		} else{
			// listen for clubsStore update and use results
			var unsubToClubsStore = this.clubsStore.listen(this.getClubInfo.bind(this));
		}
	}

	getClubInfo(clubData) {
		let clubId = parseInt(this.state.clubId, 10);
		this.state.clubInfo = _.find(clubData.clubs, (club) => {
			return club.mmsClubId === clubId;
		});
		if(this.state.clubInfo && typeof this.state.clubInfo !== 'undefined') {
			this.displayClubData();
		}
	}

	displayClubData() {
		$('strong#clubName').text(this.state.clubInfo.marketingClubName);
		$('span#juniorClubName').text(this.state.clubInfo.marketingClubName);
		if(this.state.clubInfo.juniorAccess === 'No') {
			$('p#juniorAccess').show();
		}
	}
}
